export const formatPct = (val, decimals = 2) => {
  if (val == null || isNaN(val)) return 'N/A';
  return `${(val * 100).toFixed(decimals)}%`;
};

export const formatNum = (val, decimals = 2) => {
  if (val == null || isNaN(val)) return 'N/A';
  return val.toFixed(decimals);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short' });
};

export const parseDfJson = (dfJson) => {
  if (!dfJson || !dfJson.index || !dfJson.columns) return { index: [], columns: [], data: [] };
  return dfJson;
};

export const dfToSeries = (dfJson, colIndex = 0) => {
  const { index, data } = parseDfJson(dfJson);
  return {
    x: index.map(d => new Date(d)),
    y: data.map(row => (Array.isArray(row) ? row[colIndex] : row)),
  };
};
